// extracted by mini-css-extract-plugin
export default {"snapshotSelect":"SnapshotSelect_snapshotSelect__a29p7"};